(ns frontend.view.settings2.event
  (:require [frontend.routing :as routing]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::side-nav-clicked
 (fn [{db :db} [_ path]]
   {::routing/old-routing {:path-args path}}))
